const productMediaItems = document.querySelectorAll(".product__media-item");

function filterProductMedia(variantOfSwatch) {
    variantOfSwatch = variantOfSwatch.toLowerCase();
    
    const filteredItems = Array.from(productMediaItems).filter(mediaItem => !mediaItem.classList.contains("no-alt-image"));

    const noMatch = filteredItems.every(mediaItem => {
        const image = mediaItem.querySelector("img");
        return image.getAttribute("alt") !== variantOfSwatch;
    });

    filteredItems.forEach(mediaItem => {
        mediaItem.classList.remove("is-active");
        var image = mediaItem.querySelector("img");
        if (noMatch) {
            mediaItem.style.display = "block";
        } else {
            if (image.getAttribute("alt") !== variantOfSwatch) {
                mediaItem.style.display = "none";
            } else {
                mediaItem.style.display = "block";
            }
        }
    });

    const displayedItems = filteredItems.filter(item => item.style.display === "block");
    if (displayedItems.length > 0) {
        displayedItems[0].classList.add("is-active");
    }

    const elementsWithDisplayBlock = filteredItems.filter(item => item.style.display === "block");

    elementsWithDisplayBlock.forEach(displayedElement => {
        displayedElement.addEventListener("click", function () {
            if (!this.classList.contains("is-active")) {
                elementsWithDisplayBlock.forEach(element => {
                    element.classList.remove("is-active");
                });
                this.classList.add("is-active");
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".product-form__input input[type=radio]").forEach(input => {
        if (input.checked) {
            var variantOfSwatch = input.getAttribute("data-option-value");
            filterProductMedia(variantOfSwatch);
        }
    });
});

document.querySelectorAll(".color__swatch").forEach(swatch => {
    swatch.addEventListener("click", function () {
        var variantOfSwatch = this.getAttribute("title");
        filterProductMedia(variantOfSwatch);
    });
});
